import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const UpdateAgentConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  isLoading,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="update-agent-modal-wrapper"
    >
      <Modal.Body className="pt-0 pb-2">
        <Modal.Header className="modal-title-with-border mb-0" closeButton>
          <Modal.Title>Update Agent Info?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="delete-confirmation-modal-body">
          <div className="my-3">
            <ul>
              <li>Updated Agent info will apply to existing jobs with this agent.</li>
              <li>
                This won't affect existing reports. To apply the changes, please
                recompile the reports.
              </li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer className="mt-0">
          <Button
            variant="outline-secondary"
            onClick={onHide}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Updating...
              </>
            ) : (
              "Update"
            )}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateAgentConfirmationModal;